import React from 'react';
import PropTypes, { bool } from 'prop-types';
import OverviewTable from '../base/Table/OverviewTable';
import OverviewTableRow from '../base/Table/OverviewTableRow';
import MomentOverview from '../base/MomentOverview/MomentOverview';
import textTranslates from './translate.json';
import {findComponentByComponentId} from '../../selectors/ComponentSelector';


const ComplaintPositionTable = ({position, componentsToRender}) => {

    function convertBoolToString(boolToConvert){
        if (boolToConvert === undefined || boolToConvert === false) {
            return 'NIE';
        }
        return 'TAK';
    }

    let product = findComponentByComponentId(componentsToRender,'product');
    let amount = findComponentByComponentId(componentsToRender,'amount');
    let articleSerialNumber = findComponentByComponentId(componentsToRender,'articleSerialNumber');
    let articleAssemblyAddress = findComponentByComponentId(componentsToRender,'articleAssemblyAddress');
    let faultDescription = findComponentByComponentId(componentsToRender,'faultDescription');
    let quantityCorrectionsProposal = findComponentByComponentId(componentsToRender,'quantityCorrectionsProposal');
    let articlePurchaseDate = findComponentByComponentId(componentsToRender,'articlePurchaseDate');
    let faultDate = findComponentByComponentId(componentsToRender,'faultDate');
    let articleIsNecessaryForBusiness = findComponentByComponentId(componentsToRender,'articleIsNecessaryForBusiness');
    let articleIsCompleted = findComponentByComponentId(componentsToRender,'articleIsCompleted');
    let articleHasDisassemblySigns = findComponentByComponentId(componentsToRender,'articleHasDisassemblySigns');
    let purchaseProve = findComponentByComponentId(componentsToRender,'purchaseProve');
    let additionalFiles = findComponentByComponentId(componentsToRender,'additionalFiles');
    let invoiceQuantity = findComponentByComponentId(componentsToRender,'invoiceQuantity');
    let shippedQuantity = findComponentByComponentId(componentsToRender,'shippedQuantity');
    let faultDiscoveryCircumstances = findComponentByComponentId(componentsToRender,'faultDiscoveryCircumstances');
    let customerRequest = findComponentByComponentId(componentsToRender,'customerRequest');
    let salesDocumentNumber = findComponentByComponentId(componentsToRender,'salesDocumentNumber');
    let salesDocumentPosition = findComponentByComponentId(componentsToRender,'salesDocumentPosition');
    let shipmentDescription = findComponentByComponentId(componentsToRender,'shipmentDescription');
    let dateOfReceiptOfGoods = findComponentByComponentId(componentsToRender,'dateOfReceiptOfGoods');
    let courier = findComponentByComponentId(componentsToRender,'courier');
    let purchaseAddressInput = findComponentByComponentId(componentsToRender,'purchaseAddressInput');
    let notes = findComponentByComponentId(componentsToRender, 'notes');
   
    return(
        <OverviewTable 
            tableId={`complaintPosition${position.id}TableData`}>
            <tbody>
                {product != undefined? 
                    <OverviewTableRow
                        id="product"
                        label={textTranslates.tableLabel.product}
                        value={position.product.name} />
                    :null   
                }

                {amount != undefined? 
                    <OverviewTableRow
                        id="amount"
                        label={textTranslates.tableLabel.amount}
                        value={position.amount} />
                    :null   
                }
               
                {faultDescription != undefined?
                    <OverviewTableRow
                        id="faultDescription"
                        label={textTranslates.tableLabel.faultDescription}
                        value={position.faultDescription} />:null
                }
                {faultDate != undefined?
                    <OverviewTableRow
                        id="faultDate"
                        label={textTranslates.tableLabel.faultDate}>
                        <MomentOverview moment={position.faultDate} />
                    </OverviewTableRow>:null
                }
                {faultDiscoveryCircumstances != undefined?
                    <OverviewTableRow
                        id="faultDiscoveryCircumstances"
                        label={textTranslates.tableLabel.faultDiscoveryCircumstances}
                        value={position.faultDiscoveryCircumstances} />:null
                }
                {customerRequest != undefined?
                    <OverviewTableRow
                        id="customerRequest"
                        label={textTranslates.tableLabel.customerRequest}
                        value={position.customerRequest} />:null}

                {salesDocumentNumber != undefined?
                    <OverviewTableRow
                        id="salesDocumentNumber"
                        label={textTranslates.tableLabel.salesDocumentNumber}
                        value={position.salesDocumentNumber} />:null}

                {salesDocumentPosition != undefined?
                    <OverviewTableRow
                        id="salesDocumentPosition"
                        label={textTranslates.tableLabel.salesDocumentPosition}
                        value={position.salesDocumentPosition} />:null}

                {invoiceQuantity != undefined?
                    <OverviewTableRow
                        id="invoiceQuantity"
                        label={textTranslates.tableLabel.invoiceQuantity}
                        value={position.invoiceQuantity} />:null}

                {shippedQuantity != undefined?
                    <OverviewTableRow
                        id="shippedQuantity"
                        label={textTranslates.tableLabel.shippedQuantity}
                        value={position.shippedQuantity} />:null}

                {quantityCorrectionsProposal != undefined?
                    <OverviewTableRow
                        id="quantityCorrectionsProposal"
                        label={textTranslates.tableLabel.quantityCorrectionsProposal}
                        value={position.quantityCorrectionsProposal.displayName}/>:null }

                {/* {articleSerialNumber != undefined?
                    <OverviewTableRow
                        id="articleSerialNumber"
                        label={textTranslates.tableLabel.articleSerialNumber}
                        value={position.articleSerialNumber} />:null} */}

                {shipmentDescription != undefined?
                    <OverviewTableRow
                        id="shipmentDescription"
                        label={textTranslates.tableLabel.shipmentDescription}
                        value={position.shipmentDescription} />:null}

                {dateOfReceiptOfGoods != undefined?
                    <OverviewTableRow
                        id="dateOfReceiptOfGoods"
                        label={textTranslates.tableLabel.dateOfReceiptOfGoods}>
                        <MomentOverview moment={position.dateOfReceiptOfGoods} />
                    </OverviewTableRow>:null }

                {articlePurchaseDate != undefined?
                    <OverviewTableRow
                        id="articlePurchaseDate"
                        label={textTranslates.tableLabel.purchaseDate}>
                        <MomentOverview moment={position.articlePurchaseDate}/>
                    </OverviewTableRow>:null }
                 
                {/* {articleIsCompleted != undefined?
                    <OverviewTableRow
                        id="articleIsCompleted"
                        label={"Czy artykuł jest komplenty"}
                        value={convertBoolToString(position.articleIsCompleted)} />:null} */}
                
             {/*    {articleHasDisassemblySigns != undefined? 
                    <OverviewTableRow
                    id="articleHasDisassemblySigns"
                    label={"Czy artykuł nosi ślady demontażu"}
                    value={convertBoolToString(position.articleHasDisassemblySigns)} />:null} */}
            {/* 
                {articleIsNecessaryForBusiness != undefined? 
                    <OverviewTableRow
                    id="articleIsNecessaryForBusiness"
                    label={"Czy artykuł jest używany do prowadzenia działalności gospodarczej"}
                    value={convertBoolToString(position.articleIsNecessaryForBusiness)} />:null} */}

               {/*  {articleAssemblyAddress != undefined?
                    <OverviewTableRow
                        id="articleAssemblyAddress"
                        label={"Adres montażu"}
                        value={position.articleAssemblyAddress} />:null} */}

               {/*  {articlePurchaseDate != undefined?
                    <OverviewTableRow
                        id="articlePurchaseAddress"
                        label={"Adres zakupu"}
                        value={position.articlePurchaseAddress} />:null}
                 */}
                
                </tbody>
        </OverviewTable>
    );
};

ComplaintPositionTable.propTypes = {
    position: PropTypes.object,
    componentsToRender: PropTypes.array
};

export default ComplaintPositionTable;


// WEBPACK FOOTER //
// ./src/components/ComplaintPostionOverview/ComplaintPositionTable.js